import React, { useState } from "react";
// ...existing code...

const Payment: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>("");
    const [formData, setFormData] = useState({
        amount: "",
        firstname: "",
        email: "",
        phone: "",
        productinfo: "",
    });

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const initiatePayment = async () => {
        setLoading(true);
        setError("");
        try {
            const response = await fetch("https://api.ayurwellnesstrust.com//initiate-payment", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const result = await response.json();
            if (result.status === 1 && result.data) {
                const paymentUrl = `https://pay.easebuzz.in/pay/${result.data}`;
                window.location.href = paymentUrl;
            } else {
                setError(result.error_desc || "Payment failed, try again.");
            }
        } catch (err) {
            if (err instanceof Error) {
                setError("Something went wrong: " + err.message);
            } else {
                setError("An unknown error occurred.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="payment-bg">
            <form
                onSubmit={e => { e.preventDefault(); initiatePayment(); }}
                className="payment-card"
            >
                {/* Header */}
                <div className="payment-header">
                    <h2>💳 Easebuzz Payment</h2>
                    <p>Enter your details to proceed with payment</p>
                </div>
                {/* Amount */}
                <div>
                    <label className="payment-label">Amount</label>
                        <input
                            type="text"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                            onFocus={e => ((e.target as HTMLInputElement).placeholder = "")}
                            onMouseEnter={e => ((e.target as HTMLInputElement).placeholder = "")}
                            placeholder="1.03"
                            className="payment-input"
                            required
                        />
                </div>
                {/* Firstname */}
                <div>
                    <label className="payment-label">First Name</label>
                        <input
                            type="text"
                            name="firstname"
                            value={formData.firstname}
                            onChange={handleChange}
                            onFocus={e => ((e.target as HTMLInputElement).placeholder = "")}
                            onMouseEnter={e => ((e.target as HTMLInputElement).placeholder = "")}
                            placeholder="First Name"
                            className="payment-input"
                            required
                        />
                </div>
                {/* Email */}
                <div>
                    <label className="payment-label">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            onFocus={e => ((e.target as HTMLInputElement).placeholder = "")}
                            onMouseEnter={e => ((e.target as HTMLInputElement).placeholder = "")}
                            placeholder="example@gmail.com"
                            className="payment-input"
                            required
                        />
                </div>
                {/* Phone */}
                <div>
                    <label className="payment-label">Phone</label>
                        <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            onFocus={e => ((e.target as HTMLInputElement).placeholder = "")}
                            onMouseEnter={e => ((e.target as HTMLInputElement).placeholder = "")}
                            placeholder="1231231235"
                            className="payment-input"
                            required
                        />
                </div>
                {/* Product Info */}
                <div>
                    <label className="payment-label">Product Info</label>
                        <textarea
                            name="productinfo"
                            value={formData.productinfo}
                            onChange={handleChange}
                            onFocus={e => ((e.target as HTMLTextAreaElement).placeholder = "")}
                            onMouseEnter={e => ((e.target as HTMLTextAreaElement).placeholder = "")}
                            placeholder="Test Product"
                            className="payment-textarea"
                            rows={3}
                            required
                        />
                </div>
                {/* Submit Button */}
                <button
                    type="submit"
                    disabled={loading}
                    className="payment-btn"
                >
                    {loading ? "Processing..." : "Pay Now"}
                </button>
                {/* Error */}
                {error && (
                    <p className="payment-error">{error}</p>
                )}
            </form>
        </div>
    );
};

export default Payment;
